import { MenuBurger } from '@griply/assets';
import React, { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Sizes } from 'shared/components/ui/icon-button';

import * as Styled from './drag-handle-button.style';

// `color` is omitted because IconButton reserves it for its own Colors enum; the handle fixes its own.
export type DragHandleButtonProps = Omit<
  React.ComponentProps<'button'>,
  'color'
>;

export const DragHandleButton = forwardRef<
  HTMLButtonElement,
  DragHandleButtonProps
>((props, ref) => {
  const { t } = useTranslation();

  return (
    <Styled.Button
      aria-label={t('general.labels.reorder')}
      {...props}
      ref={ref}
      icon={MenuBurger}
      size={Sizes.Small}
      strokeWidth={1.5}
    />
  );
});
